<template>
    <section class="users-list">
        <!-- <p class="users-finded">Найдено {{}} человека</p> -->
        <div class="users-body" v-show="users.users">
            <People 
                v-for="user in users.users" 
                :v-if="!loader"
                :key="user.id" 
                :user="user" 
                :friends="users.friends" 
                :offers="users.offers" 
                @click.native="openUser(user)"
                @deleteFriend="deleteFriend" 
            />
        </div>
        <div class="nothing" v-if="users.error">
            <p>Что-то пошло не так...</p>
        </div>
        <div class="nothing" v-if="!users.users">
            <p v-if="$route.name === 'friends'">У вас пока что нет друзей, <router-link :to="{name: 'users'}">добавьте новых</router-link> или <span>пригласите старых</span> друзей.</p>
            <p v-else>Ничего не найдено 💩</p>
        </div>
            
    </section>
</template>
<script>

export default {
    name: 'UserList',
    props: {
        users: {
            type: Object,
            required: false
        },
        loader: {
            type: Boolean,
            required: false
        }
    },
    components: {
        People: () => import('@/components/Users/People')
    },
    methods: {
        deleteFriend(id) {
            this.users.users.splice(this.users.users.indexOf(this.users.users.find(user => user.id === id)), 1)
        },
        openUser(user) {
            this.$router.push({name: 'user', params:{id: user.id}})
        },
    }
}
</script>